import { Box } from '@chakra-ui/react';

import { TextBold, TextRegular } from 'UiKit/typography';
import InputComponent from 'UiKit/input';

import styles from './styles.module.css';

const TITLE_MAX_LENGTH = 225;

const TitleBriefCard = ({ value, error, isFetching, register, t }) => (
  <Box className={styles['container']}>
    <TextBold className={styles['label']}>
      {t('formTalkingPoint.talkingPointTitle')}
      <span className={styles['required']}>*</span>
    </TextBold>
    <Box>
      <InputComponent
        placeholder={t('formTalkingPoint.talkingPointTitlePlaceholder')}
        value={value}
        error={error}
        isFetching={isFetching}
        isRequired
        register={register}
      />
      <TextRegular className={styles['char-counter']}>
        ({value?.length || 0}/{TITLE_MAX_LENGTH})
      </TextRegular>
    </Box>
  </Box>
);

export default TitleBriefCard;
